/* BeanBurds equipment landing page runtime — hydrates sections/bb-equipment-lp.liquid.
   Ported from the approved Lelit Bianca V3 mockup (v15). Data comes from #bbeq-data; the markup
   is server-rendered by Liquid, this file only handles state: gallery per variant, swatches,
   prices (Dirham symbol), the Tabby/Tamara figures, WhatsApp deep links, the delivery countdown,
   the sticky bar, the finish stage tabs, the official video frames, the in-the-box grouping and
   the Rapid Reviews rail. Add to cart is the theme's own product-form-component; this file never
   posts to /cart/add itself. */
(function () {
  'use strict';
  var root = document.getElementById('bbeq');
  var dataEl = document.getElementById('bbeq-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var $ = function (id) { return document.getElementById(id); };
  var BT = window.BBT || {}; function tt(k, d, o) { var s = BT[k] || d; if (o) { for (var x in o) { s = s.split('{' + x + '}').join(o[x]); } } return s; }
  var DH = '<span class="eq-dh" role="img" aria-label="' + tt('eqlp_cur', 'AED') + '"><span class="eq-sr">' + tt('eqlp_cur', 'AED') + ' </span><svg viewBox="0 0 1000 870" aria-hidden="true" focusable="false"><path d="m88.3 1c0.4 0.6 2.6 3.3 4.7 5.9 15.3 18.2 26.8 47.8 33 85.1 4.1 24.5 4.3 32.2 4.3 125.6v87h-41.8c-38.2 0-42.6-0.2-50.1-1.7-11.8-2.5-24-9.2-32.2-17.8-6.5-6.9-6.3-7.3-5.9 13.6 0.5 17.3 0.7 19.2 3.2 28.6 4 14.9 9.5 26 17.8 35.9 11.3 13.6 22.8 21.2 39.2 26.3 3.5 1 10.9 1.4 37.1 1.6l32.7 0.5v43.3 43.4l-46.1-0.3-46.3-0.3-8-3.2c-9.5-3.8-13.8-6.6-23.1-14.9l-6.8-6.1 0.4 19.1c0.5 17.7 0.6 19.7 3.1 28.7 8.7 31.8 29.7 54.5 57.4 61.9 6.9 1.9 9.6 2 38.5 2.4l30.9 0.4v89.6c0 54.1-0.3 94-0.8 100.8-0.5 6.2-2.1 17.8-3.5 25.9-6.5 37.3-18.2 65.4-35 83.6l-3.4 3.7h169.1c101.1 0 176.7-0.4 187.8-0.9 19.5-1 63-5.3 72.8-7.4 3.1-0.6 8.9-1.5 12.7-2.1 8.1-1.2 21.5-4 40.8-8.9 27.2-6.8 52-15.3 76.3-26.1 7.6-3.4 29.4-14.5 35.2-18 3.1-1.8 6.8-4 8.2-4.7 3.9-2.1 10.4-6.3 19.9-13.1 4.7-3.4 9.4-6.7 10.4-7.4 4.2-2.8 18.7-14.9 25.3-21 25.1-23.1 46.1-48.8 62.4-76.3 2.3-4 5.3-9 6.6-11.1 3.3-5.6 16.9-33.6 18.2-37.8 0.6-1.9 1.4-3.9 1.8-4.3 2.6-3.4 17.6-50.6 19.4-60.9 0.6-3.3 0.9-3.8 3.4-4.3 1.6-0.3 24.9-0.3 51.8-0.1 53.8 0.4 53.8 0.4 65.7 5.9 6.7 3.1 8.7 4.5 16.1 11.2 9.7 8.7 8.8 10.1 8.2-11.7-0.4-12.8-0.9-20.7-1.8-23.9-3.4-12.3-4.2-14.9-7.2-21.1-9.8-21.4-26.2-36.7-47.2-44l-8.2-3-33.4-0.4-33.3-0.5 0.4-11.7c0.4-15.4 0.4-45.9-0.1-61.6l-0.4-12.6 44.6-0.2c38.2-0.2 45.3 0 49.5 1.1 12.6 3.5 21.1 8.3 31.5 17.8l5.8 5.4v-14.8c0-17.6-0.9-25.4-4.5-37-7.1-23.5-21.1-41-41.1-51.8-13-7-13.8-7.2-58.5-7.5-26.2-0.2-39.9-0.6-40.6-1.2-0.6-0.6-1.1-1.6-1.1-2.4 0-0.8-1.5-7.1-3.5-13.9-23.4-82.7-67.1-148.4-131-197.1-8.7-6.7-30-20.8-38.6-25.6-3.3-1.9-6.9-3.9-7.8-4.5-4.2-2.3-28.3-14.1-34.3-16.6-3.6-1.6-8.3-3.6-10.4-4.4-35.3-15.3-94.5-29.8-139.7-34.3-7.4-0.7-17.2-1.8-21.7-2.2-20.4-2.3-48.7-2.6-209.4-2.6-135.8 0-169.9 0.3-169.4 1zm330.7 43.3c33.8 2 54.6 4.6 78.9 10.5 74.2 17.6 126.4 54.8 164.3 117 3.5 5.8 18.3 36 20.5 42.1 10.5 28.3 15.6 45.1 20.1 67.3 1.1 5.4 2.6 12.6 3.3 16 0.7 3.3 1 6.4 0.7 6.7-0.5 0.4-100.9 0.6-223.3 0.5l-222.5-0.2-0.3-128.5c-0.1-70.6 0-129.3 0.3-130.4l0.4-1.9h71.1c39 0 78 0.4 86.5 0.9zm297.5 350.3c0.7 4.3 0.7 77.3 0 80.9l-0.6 2.7-227.5-0.2-227.4-0.3-0.2-42.4c-0.2-23.3 0-42.7 0.2-43.1 0.3-0.5 97.2-0.8 227.7-0.8h227.2zm-10.2 171.7c0.5 1.5-1.9 13.8-6.8 33.8-5.6 22.5-13.2 45.2-20.9 62-3.8 8.6-13.3 27.2-15.6 30.7-1.1 1.6-4.3 6.7-7.1 11.2-18 28.2-43.7 53.9-73 72.9-10.7 6.8-32.7 18.4-38.6 20.2-1.2 0.3-2.5 0.9-3 1.3-0.7 0.6-9.8 4-20.4 7.8-19.5 6.9-56.6 14.4-86.4 17.5-19.3 1.9-22.4 2-96.7 2h-76.9v-129.7-129.8l220.9-0.4c121.5-0.2 221.6-0.5 222.4-0.7 0.9-0.1 1.8 0.5 2.1 1.2z"/></svg></span>';

  function fmt(cents, decimals) {
    var n = cents / 100;
    var opts = decimals ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 };
    return n.toLocaleString('en-US', opts);
  }
  function money(cents, decimals) { return DH + fmt(cents, decimals); }
  function moneyText(cents) { return BT.eqlp_money ? tt('eqlp_money', '', { n: fmt(cents) }) : 'AED ' + fmt(cents); }

  var variants = D.variants || [];
  var current = 0, slide = 0;
  for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(D.initial)) current = i; }

  var track = $('eq-gtrack'), dots = $('eq-gdots'), thumbs = $('eq-gthumbs'), swatches = $('eq-swatches');
  var stage = $('eq-gstage');

  /* ---------- dimension diagram ---------- */
  function dimSvg() {
    var d = D.dims || {};
    if (!d.w || !d.h) return '';
    var note = [];
    if (d.note) note.push(d.note);
    if (d.weight) note.push(BT.eqlp_kg ? tt('eqlp_kg', '', { n: d.weight }) : d.weight + ' kg');
    var label = BT.eqlp_dim_aria ? tt(d.d ? 'eqlp_dim_aria' : 'eqlp_dim_aria_nd', '', { name: D.short, w: d.w, d: d.d || '', h: d.h }) + (d.note ? tt('eqlp_sep', ', ') + d.note : '') : D.short + ' dimensions: ' + d.w + ' centimetres wide, ' + (d.d || '') + ' deep, ' + d.h + ' high' + (d.note ? ', ' + d.note : '');
    return '<svg viewBox="0 0 460 400" role="img" aria-label="' + label.replace(/"/g, '&quot;') + '">' +
      '<g fill="none" stroke="#2B745E" stroke-width="2">' +
      '<rect x="120" y="80" width="200" height="230" rx="10"/>' +
      '<path d="M320 80l60 -34v230l-60 34z"/><path d="M120 80l60 -34h200l-60 34z"/>' +
      '</g>' +
      '<g font-family="Instrument Sans,Arial,sans-serif" font-size="17" fill="#111311" font-weight="600" text-anchor="middle">' +
      '<text x="220" y="345">' + tt('eqlp_cm_w', '{n} cm wide', { n: d.w }) + '</text>' +
      '<text x="420" y="200" transform="rotate(90 420 200)">' + tt('eqlp_cm_h', '{n} cm high', { n: d.h }) + '</text>' +
      (d.d ? '<text x="255" y="38">' + tt('eqlp_cm_d', '{n} cm deep', { n: d.d }) + '</text>' : '') +
      '</g>' +
      (note.length ? '<g font-family="Instrument Sans,Arial,sans-serif" font-size="13" fill="#6B706C" text-anchor="middle"><text x="220" y="372">' + note.join(' · ') + '</text></g>' : '') +
      '</svg>';
  }

  /* ---------- gallery ---------- */
  function ytPoster(m) { return m.poster || ('https://i.ytimg.com/vi/' + m.yt + '/hqdefault.jpg'); }
  function buildGallery() {
    var v = variants[current];
    var media = (v.media || []).filter(function (m) { return m.t !== 'dim' || (D.dims && D.dims.w); });
    track.innerHTML = ''; dots.innerHTML = ''; thumbs.innerHTML = '';
    media.forEach(function (m, i) {
      var s = document.createElement('div');
      var t = document.createElement('button');
      t.type = 'button'; t.setAttribute('role', 'tab');
      if (m.t === 'dim') {
        s.className = 'eq-gslide eq-dim';
        s.innerHTML = dimSvg();
        t.className = 'eq-gthumb eq-pad';
        t.setAttribute('aria-label', tt('eqlp_dim_diag', 'Dimensions diagram'));
        t.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2B745E" stroke-width="1.8"><rect x="4" y="7" width="16" height="12" rx="2"/><path d="M4 4v2M20 4v2M4 5h16"/></svg>';
      } else if (m.t === 'img') {
        s.className = 'eq-gslide' + (m.full ? ' eq-full' : '') + (m.fit ? ' eq-fit' : '');
        var im = document.createElement('img'); im.src = m.src; im.alt = m.alt || ''; im.decoding = 'async';
        if (i > 0) im.loading = 'lazy';
        s.appendChild(im);
        t.className = 'eq-gthumb' + ((!m.full || m.fit) ? ' eq-pad' : '');
        t.setAttribute('aria-label', BT.eqlp_img_n ? tt('eqlp_img_n', '', { i: i + 1, n: media.length }) : 'Image ' + (i + 1) + ' of ' + media.length);
        var ti = document.createElement('img'); ti.src = m.src; ti.alt = ''; ti.loading = 'lazy'; t.appendChild(ti);
      } else {
        s.className = 'eq-gslide eq-vslide';
        var p = document.createElement('img'); p.className = 'eq-poster'; p.src = ytPoster(m); p.alt = ''; p.loading = 'lazy';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'eq-playbtn'; b.setAttribute('aria-label', m.alt || (BT.eqlp_play ? tt('eqlp_play', '', { t: m.cap || tt('eqlp_video_lc', 'video') }) : 'Play: ' + (m.cap || 'video')));
        b.innerHTML = '<svg width="26" height="26" viewBox="0 0 24 24" fill="#123B31" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
        var c = document.createElement('span'); c.className = 'eq-vcap'; c.textContent = m.cap || '';
        b.addEventListener('click', function () {
          var f = document.createElement('iframe');
          f.src = 'https://www.youtube-nocookie.com/embed/' + m.yt + '?autoplay=1&rel=0';
          f.title = m.cap || tt('eqlp_video', 'Video'); f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
          s.appendChild(f); b.hidden = true;
        });
        s.appendChild(p); s.appendChild(b); s.appendChild(c);
        t.className = 'eq-gthumb';
        t.setAttribute('aria-label', BT.eqlp_video_cap ? tt('eqlp_video_cap', '', { t: m.cap || '' }) : 'Video: ' + (m.cap || ''));
        var tv = document.createElement('img'); tv.src = ytPoster(m); tv.alt = ''; tv.loading = 'lazy'; t.appendChild(tv);
        var ov = document.createElement('span'); ov.className = 'eq-tply';
        ov.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>'; t.appendChild(ov);
      }
      track.appendChild(s);
      var d = document.createElement('i'); dots.appendChild(d);
      t.addEventListener('click', function () { go(i); });
      thumbs.appendChild(t);
    });
    slide = 0; paint();
  }
  function paint() {
    var n = track.children.length;
    track.style.transform = 'translateX(' + (-slide * 100) + '%)';
    [].forEach.call(dots.children, function (d, i) { d.className = (i === slide ? 'eq-on' : ''); });
    [].forEach.call(thumbs.children, function (t, i) {
      t.classList.toggle('eq-on', i === slide);
      t.setAttribute('aria-selected', i === slide ? 'true' : 'false');
    });
    $('eq-gprev').hidden = n < 2; $('eq-gnext').hidden = n < 2; dots.hidden = n < 2;
    [].forEach.call(track.querySelectorAll('.eq-vslide'), function (vs) {
      var f = vs.querySelector('iframe');
      if (f && [].indexOf.call(track.children, vs) !== slide) { f.remove(); var b = vs.querySelector('.eq-playbtn'); if (b) b.hidden = false; }
    });
  }
  function go(i) { var n = track.children.length; if (!n) return; slide = (i + n) % n; paint(); }
  $('eq-gprev').addEventListener('click', function () { go(slide - 1); });
  $('eq-gnext').addEventListener('click', function () { go(slide + 1); });
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(slide - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(slide + 1); }
  });
  var sx = null;
  track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 40) go(slide + (dx < 0 ? 1 : -1));
    sx = null;
  }, { passive: true });

  /* ---------- variants ---------- */
  function buildSwatches() {
    if (!swatches) return;
    variants.forEach(function (v, i) {
      var wrap = document.createElement('div'); wrap.className = 'eq-swx';
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'eq-sw' + (v.available ? '' : ' eq-oos');
      b.setAttribute('aria-label', v.label + tt('eqlp_sep', ', ') + moneyText(v.price) + (v.available ? '' : tt('eqlp_sep', ', ') + tt('eqlp_unavail_lc', 'currently unavailable')) + (v.popular ? tt('eqlp_sep', ', ') + tt('eqlp_popular_lc', 'most popular') : ''));
      var im = document.createElement('img'); im.src = v.swatch || v.image || ''; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () { select(i, true); });
      if (v.popular) { var mp = document.createElement('span'); mp.className = 'eq-mp'; mp.textContent = tt('eqlp_popular', 'MOST POPULAR'); wrap.appendChild(mp); }
      var nm = document.createElement('span'); nm.className = 'eq-swname'; nm.textContent = v.label.replace('Stainless ', '');
      var pr = document.createElement('span'); pr.className = 'eq-swprice' + (v.available ? '' : ' eq-oos');
      if (v.available) pr.innerHTML = money(v.price); else pr.textContent = tt('eqlp_unavail', 'Unavailable');
      wrap.appendChild(b); wrap.appendChild(nm); wrap.appendChild(pr);
      swatches.appendChild(wrap);
    });
  }
  function setHtml(id, html) { var el = $(id); if (el) el.innerHTML = html; }
  function setText(id, txt) { var el = $(id); if (el) el.textContent = txt; }
  function select(i, fromUser) {
    current = i;
    var v = variants[i];
    if (swatches) [].forEach.call(swatches.querySelectorAll('.eq-sw'), function (b, k) { b.classList.toggle('eq-on', k === i); });
    setText('eq-swName', v.label);
    var oos = $('eq-swOos'); if (oos) oos.hidden = v.available;
    setHtml('eq-pMain', money(v.price));
    setText('eq-tamaraAmt', fmt(v.price / 4, true));
    setText('eq-tabbyAmt', fmt(Math.round(v.price * (D.tabbyRatio || 0))));
    setHtml('eq-sMain', money(v.price));
    var st = $('eq-sThumb'); if (st && (v.swatch || v.image)) st.src = v.swatch || v.image;
    setHtml('eq-bundleMachine', money(v.price));
    setHtml('eq-bundlePay', money(v.price) + (D.taxesIncluded ? '' : ' ' + tt('eqlp_excl_vat', 'excl. VAT')));

    /* the theme's product form: switch the variant it will add */
    var vid = root.querySelector('input[name="id"]'); if (vid) vid.value = v.id;
    var add = $('eq-addBtn'), sadd = $('eq-sAdd'), buyWrap = $('eq-buyWrap');
    if (add) { add.setAttribute('data-variant-id', v.id); add.disabled = !v.available; var t = add.querySelector('.eq-t'); if (t) t.textContent = v.available ? tt('eqlp_add', 'Add to cart') : tt('eqlp_unavail_now', 'Currently unavailable'); }
    if (sadd) { sadd.disabled = !v.available; var t2 = sadd.querySelector('.eq-t'); if (t2) t2.textContent = v.available ? tt('eqlp_add', 'Add to cart') : tt('eqlp_unavail', 'Unavailable'); }
    if (buyWrap) buyWrap.hidden = !v.available;

    var waText = BT.eqlp_wa_q ? tt(v.label ? 'eqlp_wa_q' : 'eqlp_wa_q1', '', { title: D.title, v: v.label }) : 'Hi BeanBurds, I am looking at the ' + D.title + ' (' + v.label + ') and have a question.';
    var waHref = 'https://wa.me/' + D.whatsapp + '?text=' + encodeURIComponent(waText);
    var wab = $('eq-waBtn'); if (wab) { wab.href = waHref; wab.textContent = v.available ? tt('eqlp_ask_wa', 'Ask a barista on WhatsApp') : tt('eqlp_stock_wa', 'WhatsApp us for stock news'); }
    var swa = $('eq-sWa'); if (swa) swa.href = waHref;
    var splitWa = $('eq-splitWa');
    if (splitWa) {
      var splitText = BT.eqlp_wa_split ? tt(v.label ? 'eqlp_wa_split' : 'eqlp_wa_split1', '', { title: D.title, v: v.label, total: moneyText(v.price), vat: D.taxesIncluded ? tt('eqlp_incl_vat', 'incl. VAT') : tt('eqlp_excl_vat_long', 'excluding VAT') }) : "Hi BeanBurds, I'd like to arrange a split payment for the " + D.title + ' (' + v.label + '), total ' + moneyText(v.price) + (D.taxesIncluded ? ' incl. VAT' : ' excluding VAT') + '. Please help me divide it across Tabby, Tamara, card, bank transfer, or cash.';
      splitWa.href = 'https://wa.me/' + D.whatsapp + '?text=' + encodeURIComponent(splitText);
    }
    if (fromUser && window.history && history.replaceState) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    /* finish stage follows the chosen finish */
    setFinish(i, false);
    buildGallery();
  }

  /* ---------- finish stage (story layout "finishes") ---------- */
  var fin = $('eq-finstage');
  function setFinish(i, scroll) {
    if (!fin) return;
    var imgs = fin.querySelectorAll('img'), tabs = fin.querySelectorAll('.eq-fs-tab');
    [].forEach.call(imgs, function (im, k) { im.classList.toggle('eq-on', k === i); });
    [].forEach.call(tabs, function (tb, k) { tb.classList.toggle('eq-on', k === i); tb.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
  }
  if (fin) [].forEach.call(fin.querySelectorAll('.eq-fs-tab'), function (tb) {
    tb.addEventListener('click', function () { setFinish(parseInt(tb.getAttribute('data-i'), 10) || 0); });
  });

  /* ---------- split-payment row reuses the instalment box wordmarks ---------- */
  [].forEach.call(root.querySelectorAll('[data-payment-logo]'), function (target) {
    var source = root.querySelector('.eq-paylogo.' + target.getAttribute('data-payment-logo') + ' svg');
    if (!source) return;
    target.textContent = '';
    target.appendChild(source.cloneNode(true));
  });

  /* ---------- delivery countdown (UAE only) ---------- */
  function computeDelivery(now, cfg) {
    function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
    function f(d) { return d.toLocaleDateString(tt('eqlp_date_loc', 'en-GB'), { weekday: 'long', day: 'numeric', month: 'short' }); }
    var cutoff = new Date(now); cutoff.setHours(cfg.cutoffHour, 0, 0, 0);
    if (now < cutoff) {
      var ms = cutoff - now, h = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000);
      if (BT.eqlp_dlv_cut) return tt('eqlp_dlv_cut', '', { h: h, m: (m < 10 ? '0' : '') + m, date: f(addDays(now, 1)), free: cfg.freeText });
      return 'Order in the next <b>' + h + 'h ' + (m < 10 ? '0' : '') + m + 'm</b> for delivery tomorrow, <b>' + f(addDays(now, 1)) + '</b>. ' + cfg.freeText;
    }
    if (BT.eqlp_dlv_late) return tt('eqlp_dlv_late', '', { date: f(addDays(now, 2)), cut: cfg.cutoffHour, free: cfg.freeText });
    return 'Order now and it arrives <b>' + f(addDays(now, 2)) + '</b>. Orders after ' + cfg.cutoffHour + ':00 are processed the next day. ' + cfg.freeText;
  }
  function uaeNow() { var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + (D.delivery.tzOffset || 4) * 3600000); }
  function tickDelivery() { if (D.isHome) setHtml('eq-deliveryMsg', computeDelivery(uaeNow(), D.delivery)); }
  window.__bbeqComputeDelivery = computeDelivery;

  /* ---------- official video frames ---------- */
  [].forEach.call(root.querySelectorAll('.eq-vframe[data-yt]'), function (fr) {
    var btn = fr.querySelector('.eq-playbtn'); if (!btn) return;
    btn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + fr.getAttribute('data-yt') + '?autoplay=1&rel=0';
      f.title = fr.getAttribute('data-title') || tt('eqlp_video', 'Video'); f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      fr.appendChild(f); btn.hidden = true;
    });
  });

  /* ---------- sticky buy bar ---------- */
  var addBtn = $('eq-addBtn'), bar = $('eq-stickybuy');
  if (addBtn && bar && 'IntersectionObserver' in window) {
    var mq = window.matchMedia('(max-width: 720px)');
    new IntersectionObserver(function (e) {
      var show = !e[0].isIntersecting;
      bar.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
      document.body.style.paddingBottom = (show && mq.matches) ? '78px' : '';
    }, { rootMargin: '-10px' }).observe(addBtn);
    bar.style.transition = 'transform .25s ease';
  }

  /* ---------- in the box: group heading + list pairs, tag bullet paragraphs ---------- */
  (function () {
    var rt = $('eq-boxrt'); if (!rt) return;
    var inner = rt.querySelector('.metafield-rich_text_field') || rt;
    var nodes = [].slice.call(inner.children), out = document.createElement('div'), group = null;
    nodes.forEach(function (n) {
      var tag = n.tagName;
      if (/^H[1-6]$/.test(tag) || (tag === 'P' && n.children.length === 1 && n.firstElementChild.tagName === 'STRONG' && n.textContent.trim() === n.firstElementChild.textContent.trim())) {
        group = document.createElement('div'); group.appendChild(n); out.appendChild(group); return;
      }
      if (tag === 'P') {
        var txt = n.textContent.trim();
        if (/^[•\-–·*]\s*/.test(txt)) {
          n.textContent = txt.replace(/^[•\-–·*]\s*/, ''); n.className = 'eq-li';
          if (!group) { group = document.createElement('div'); out.appendChild(group); }
          group.appendChild(n); return;
        }
        if (!txt) return;
        n.className = 'eq-lead'; out.appendChild(n); return;
      }
      if (!group) { group = document.createElement('div'); out.appendChild(group); }
      group.appendChild(n);
    });
    inner.innerHTML = ''; while (out.firstChild) inner.appendChild(out.firstChild);
  })();

  /* ---------- reviews rail: the Rapid Reviews app renders its own list; wire the arrows to it ---------- */
  (function () {
    var prev = $('eq-rprev'), next = $('eq-rnext'), items = document.getElementById('rapid_reviews_items'), tries = 0;
    if (!prev || !next) return;
    function find() {
      var track = document.querySelector('#rapid_reviews_items .r_items_list > ul');
      if (!track) {
        if (++tries < 120) { setTimeout(find, 150); return; }
        if (items) items.classList.add('eq-ready');
        prev.parentNode.hidden = true; return;
      }
      var write = document.querySelector('#rapid_reviews_items .r_prompt_links a');
      if (write) { write.className = 'eq-revwrite'; var rw = $('eq-rwrite'); if (rw) rw.appendChild(write); }
      var n = track.querySelectorAll('li.r_item').length, note = $('eq-revnote');
      if (note && n) note.textContent = note.textContent.replace(/\s*·.*$/, '') + ' · ' + (BT.eqlp_recent ? tt('eqlp_recent', '', { n: n }) : n + ' most recent shown');
      track.setAttribute('role', 'region');
      track.setAttribute('aria-label', tt('eqlp_rev_scroll', 'Customer reviews, scroll sideways'));
      track.tabIndex = 0;
      track.scrollLeft = 0;
      function step() { var li = track.querySelector('li'); return li ? li.getBoundingClientRect().width + 14 : 316; }
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.style.cursor = 'grabbing';
      });
      window.addEventListener('pointerup', function () { down = false; track.style.cursor = ''; });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var d = e.clientX - sx; if (Math.abs(d) > 4) moved = true;
        track.scrollLeft = sl - d;
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      if (items) items.classList.add('eq-ready');
      upd();
    }
    find();
  })();

  /* editorial text (FAQ answers, story copy, fine print) still says "AED 800": swap the token for the symbol */
  (function () {
    var re = /AED\s?(?=\d)/;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [], n;
    while ((n = walker.nextNode())) { if (re.test(n.nodeValue) && !n.parentNode.closest('script,style,#bbeq-data,.eq-dh')) hits.push(n); }
    hits.forEach(function (t) {
      var parts = t.nodeValue.split(/AED\s?(?=\d)/), frag = document.createDocumentFragment();
      parts.forEach(function (p, i) {
        if (i) { var s = document.createElement('span'); s.innerHTML = DH; frag.appendChild(s.firstChild); }
        frag.appendChild(document.createTextNode(p));
      });
      t.parentNode.replaceChild(frag, t);
    });
  })();

  /* ---------- in-page jumps ("See the list", "Watch"): the theme scrolls inside .page-wrapper, not the
     window, so a plain hash link does not move the page; scroll the target into view ourselves ---------- */
  (function () {
    function jump(el) {
      /* 'instant' on purpose: the wrapper carries scroll-behavior:smooth and its animated scrolls get
         cancelled mid-way by the theme's own scroll work, so the page would stop after a few pixels */
      [].forEach.call(el.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
      el.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]'); if (!a) return;
      var id = a.getAttribute('href').slice(1); if (!id) return;
      var el = document.getElementById(id); if (!el || !root.contains(el)) return;
      e.preventDefault();
      jump(el);
      try { history.replaceState(null, '', '#' + id); } catch (_) {}
    });
    if (location.hash && location.hash.length > 1) {
      var t = document.getElementById(location.hash.slice(1));
      if (t && root.contains(t)) setTimeout(function () { jump(t); }, 250);
    }
  })();

  buildSwatches();
  select(current, false);
  tickDelivery();
  setInterval(tickDelivery, 30000);
})();
